export enum ToolCategory {
  PUNCH = 'PUNCH',
  DIE = 'DIE',
  INSERT = 'INSERT',
  LIGHTWEIGHT_TOOLING = 'LIGHTWEIGHT_TOOLING',
  ADAPTER = 'ADAPTER',
}
